// Phase 17-D item 7 — shared metric metadata for /impact pages.
import { Clock3, Users, HeartHandshake, MapPinned, Coffee, Building2 } from "lucide-react";

export const IMPACT_METRICS = [
  { key: "hours", label: "Volunteer hours", icon: Clock3 },
  { key: "volunteers", label: "Active volunteers", icon: Users },
  { key: "help_fulfilled", label: "Help requests fulfilled", icon: HeartHandshake },
  { key: "collectives", label: "Collectives", icon: MapPinned },
  { key: "gatherings", label: "Gatherings", icon: Coffee },
  { key: "orgs", label: "Partner organisations", icon: Building2 },
];

// Suppressed metrics render as "<5" — aggregates over individuals.
export const metricDisplay = (m) => (m?.suppressed ? "<5" : String(m?.value ?? 0));

export const monthLabel = (ym) => {
  const [y, mo] = (ym || "").split("-");
  const names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${names[(parseInt(mo, 10) || 1) - 1]} ${(y || "").slice(2)}`;
};
